import { t } from "i18next";
import { CrossIcon } from "../../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { JcKey } from "../../services/jcEntity";
import { cancelJobCardurl, CancellationReasonList } from "../../services/JobCardApiCall";
import { ReactComponent as AlertIcon } from '../../../../assets/images/alert-circle.svg';
var NewCancelPopup = function (props) {
    var onClose = props.onClose, state = props.state;
    var formdata = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            alignItems: 'center',
            padding: 2,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    alignItems: "center",
                    // padding: 2,
                    elements: [{
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(AlertIcon, {
                                height: '20px',
                                width: '20px',
                                color: "#CC7A00"
                            }),
                            columnSize: 0,
                            sx: {
                                bgcolor: '#FFE7D4',
                                cursor: 'default',
                                padding: '12px',
                                ':hover': {
                                    bgcolor: '#FFE7D4'
                                }
                            }
                        }, {
                            type: FormItemTypes.IconButton,
                            name: "",
                            label: "",
                            value: null,
                            children: /*#__PURE__*/ React.createElement(CrossIcon, {
                                sx: {
                                    height: "14px",
                                    width: "14px"
                                }
                            }),
                            // columnSize: 12,
                            onClick: function () {
                                onClose();
                            },
                            columnSize: 0
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    columnSize: 12,
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            label: "",
                            value: null,
                            children: "Cancel job card",
                            // variant: 'h1',
                            fontWeight: "strong",
                            fontSize: "xl",
                            flexDirection: "column",
                            columnGap: 2,
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: "",
                            value: null,
                            children: t("Are you sure you want to cancel this job card? This action cannot be undone.."),
                            fontSize: "base",
                            color: "secondary.500",
                            fontWeight: "normal",
                            flexDirection: "column",
                            columnGap: 2,
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'ReasonId',
                    label: 'Reason',
                    placeholder: 'Select a reason',
                    value: null,
                    displayExpr: "Name",
                    valueExpr: "id",
                    required: true,
                    setFormState: function () { return ({
                        RejectRemarkId: null
                    }); },
                    getListData: CancellationReasonList,
                    apiKey: JcKey.CancellationReasonList,
                    apiRequest: {
                        SystemName: "JobCard"
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Remarks (0/500 characters)',
                    placeholder: 'Write reason here...',
                    maxLength: 500,
                    value: null,
                    minRows: 3,
                    multiline: true,
                    required: true,
                    setFieldProps: function (formValues, value) {
                        var _value$length;
                        return {
                            type: this.type,
                            label: "Remark (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/500 characters)")
                        };
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    label: '',
                    children: 'Confirm',
                    columnSize: 12,
                    fullWidth: true,
                    variant: 'contained',
                    onClick: function () { return 'submit'; },
                    setFieldProps: function (formValues) {
                        return {
                            type: this.type,
                            disabled: !(formValues !== null && formValues !== void 0 && formValues.ReasonId) || !(formValues !== null && formValues !== void 0 && formValues.Remarks)
                        };
                    }
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    value: null,
                    children: 'Cancel',
                    columnSize: 12,
                    onClick: function () {
                        onClose();
                    },
                    fullWidth: true,
                    variant: 'outlined'
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        mode: "add",
        gridProps: {
            spacing: 0
        },
        formData: formdata,
        createFormAPI: cancelJobCardurl,
        createKey: JcKey.CancelJobCard,
        createRequest: {
            id: state
        },
        onClose: function (e, isUpdated) {
            console.log(isUpdated);
            if (isUpdated)
                onClose(isUpdated);
        },
        pagingAPIKey: JcKey.JcPaging
    }));
};
export default NewCancelPopup;
